import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  messageTemplates: [],
  messageTemplatesStatus: IDLE,

  predefinedMessageTemplates: [],
  predefinedMessageTemplatesStatus: IDLE,

  createMessageTemplateStatus: IDLE,
  updateMessageTemplateStatus: IDLE,
  deleteMessageTemplateStatus: IDLE
};

const messageTemplatesSlice = createSlice({
  name: 'messageTemplates',
  initialState,
  reducers: {
    getMessageTemplates(state) {
      state.messageTemplatesStatus = LOADING;
    },
    getMessageTemplatesSucceeded(state, action) {
      state.messageTemplatesStatus = SUCCEEDED;
      state.messageTemplates = action.payload;
    },
    getMessageTemplatesFailed(state) {
      state.messageTemplatesStatus = FAILED;
    },

    getPredefinedMessageTemplates(state) {
      state.predefinedMessageTemplatesStatus = LOADING;
    },
    getPredefinedMessageTemplatesSucceeded(state, action) {
      state.predefinedMessageTemplatesStatus = SUCCEEDED;
      state.predefinedMessageTemplates = action.payload;
    },
    getPredefinedMessageTemplatesFailed(state) {
      state.predefinedMessageTemplatesStatus = FAILED;
    },

    createMessageTemplate(state) {
      state.createMessageTemplateStatus = LOADING;
    },
    createMessageTemplateSucceeded(state) {
      state.createMessageTemplateStatus = SUCCEEDED;
    },
    createMessageTemplateFailed(state) {
      state.createMessageTemplateStatus = FAILED;
    },

    updateMessageTemplate(state) {
      state.updateMessageTemplateStatus = LOADING;
    },
    updateMessageTemplateSucceeded(state) {
      state.updateMessageTemplateStatus = SUCCEEDED;
    },
    updateMessageTemplateFailed(state) {
      state.updateMessageTemplateStatus = FAILED;
    },

    deleteMessageTemplate(state) {
      state.deleteMessageTemplateStatus = LOADING;
    },
    deleteMessageTemplateSucceeded(state) {
      state.deleteMessageTemplateStatus = SUCCEEDED;
    },
    deleteMessageTemplateFailed(state) {
      state.deleteMessageTemplateStatus = FAILED;
    },

    clearMessageTemplates(state) {
      state.messageTemplates = [];
      state.messageTemplatesStatus = IDLE;
    }
  }
});

export const {
  getMessageTemplates,
  clearMessageTemplates,
  getMessageTemplatesSucceeded,
  getMessageTemplatesFailed,
  getPredefinedMessageTemplates,
  getPredefinedMessageTemplatesSucceeded,
  getPredefinedMessageTemplatesFailed,
  createMessageTemplate,
  createMessageTemplateSucceeded,
  createMessageTemplateFailed,
  updateMessageTemplate,
  updateMessageTemplateSucceeded,
  updateMessageTemplateFailed,
  deleteMessageTemplate,
  deleteMessageTemplateSucceeded,
  deleteMessageTemplateFailed
} = messageTemplatesSlice.actions;

export default messageTemplatesSlice.reducer;
